var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.own)?_c('div'):(_vm.isFollowingProxy)?_c('button',{staticClass:"btn passive",on:{"click":_vm.unFollow}},[_c('SubscribedIcon'),_vm._v(_vm._s(_vm.$t("subscribed"))+" ")],1):_c('button',{staticClass:"btn light",on:{"click":_vm.follow}},[_vm._v(" "+_vm._s(_vm.$t("subscribe"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }